// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__2V6AJ","error":"input_error__T12sL","correct":"input_correct__1mxgn"};